import cls from 'classnames';
import Image from 'next/image';
import React from 'react';

import AndroidRobot from '@/components/Icon/AndroidRobot';
import Apple from '@/components/Icon/Apple';
import GoogleIcon from '@public/images/common/google.svg';

import type { HoverQrType } from '../../data';

interface IDownloadButton {
  type: HoverQrType;
  line1: string;
  line2: string;
  onClick?(): void;
  showQR?: boolean;
  onHoverQr?(visible: boolean): void;
}

const DownloadButton: React.FC<IDownloadButton> = ({
  type,
  line1,
  line2,
  onClick,
  showQR,
  onHoverQr,
}) => {
  const renderIcon = () => {
    if (type === 'Apple') {
      return (
        <Apple
          className="relative h-[20px] w-[20px] shrink-0 overflow-clip xl:h-[28px] xl:w-[28px]"
          fill="white"
        />
      );
    }
    if (type === 'AndroidApk') {
      return (
        <AndroidRobot
          className="relative h-[20px] w-[20px] shrink-0 overflow-clip xl:h-[28px] xl:w-[28px]"
          fill="white"
        />
      );
    }
    return (
      <Image
        className="relative h-[20px] w-[20px] shrink-0 overflow-clip xl:h-[28px] xl:w-[28px]"
        alt="google play"
        width={28}
        height={28}
        src={GoogleIcon}
        quality={100}
      />
    );
  };

  const isAndroidApkFullHover = type === 'AndroidApk' && showQR;

  return (
    <div
      className={cls(
        'relative flex h-[60px] w-full items-center justify-center gap-[4px] rounded-[12px] border-[1.267px] border-solid border-[#c6c7d2] bg-black px-[8px] text-white',
        'xl:h-[80px] xl:gap-[8px] xl:rounded-[16px] xl:px-[16px]',
        isAndroidApkFullHover ? 'cursor-default' : 'cursor-pointer',
      )}
      onClick={isAndroidApkFullHover ? undefined : onClick}
      onMouseEnter={isAndroidApkFullHover ? () => onHoverQr?.(true) : undefined}
      onMouseLeave={
        isAndroidApkFullHover ? () => onHoverQr?.(false) : undefined
      }>
      {renderIcon()}
      <div className="flex shrink-0 flex-col items-start justify-center gap-[2px] whitespace-nowrap xl:gap-0 xl:leading-[1.2]">
        <p className="relative shrink-0 text-[11px] font-medium leading-[1.2] xl:text-[12px]">
          {line1}
        </p>
        <p className="relative shrink-0 text-[13px] font-bold leading-[1.3] xl:text-[20px] xl:font-extrabold xl:leading-[1.2]">
          {line2}
        </p>
      </div>
      {showQR && (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        <div
          className="absolute right-0 top-0 h-[28px] w-[28px] rounded-tr-[11px] bg-[url('/images/download/QRbg-lg.png')] bg-cover xl:h-[36px] xl:w-[36px] xl:rounded-tr-[15px] xl:bg-[url('/images/download/QRbg-xl.png')]"
          onMouseEnter={
            isAndroidApkFullHover ? undefined : () => onHoverQr?.(true)
          }
          onMouseLeave={
            isAndroidApkFullHover ? undefined : () => onHoverQr?.(false)
          }
        />
      )}
    </div>
  );
};

export default DownloadButton;
